import { withResult } from 'feathers-fletching';
import { disallow } from 'feathers-hooks-common';
import { statusType } from 'straightline-utils/constants';

const withResults = withResult({
  from_status: (result) => {
    if (result.from_status_type) {
      return statusType(result.from_status_type);
    }
  },
  to_status: (result) => {
    if (result.to_status_type) {
      return statusType(result.to_status_type);
    }
  }
});

export default {
  before: {
    all: [],
    find: [],
    get: [],
    create: [disallow()],
    update: [disallow()],
    patch: [disallow()],
    remove: [disallow()]
  },
  after: {
    all: [withResults],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
};
